import { RouterStore } from 'mobx-react-router';

const store = new RouterStore();

export default store;
